import { useData } from "../../context/DataContext";
import { C } from "../../styles/theme";
import { MONTHS } from "../AdminUI";

export default function AnalyticsTab() {
  const { db } = useData();
  const an = db.analytics || {};
  const rev = (db.orders || []).filter(o => o.status === "delivered").reduce((s, o) => s + o.amount, 0);

  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 13, marginBottom: 18 }}>
        {[["Total Leads", (db.leads || []).length, C.orange], ["Total Revenue", "Rs." + rev.toLocaleString(), C.teal], ["Blog Views", (an.monthlyViews || []).reduce((a, b) => a + b, 0).toLocaleString(), C.blue]].map(([l, v, c]) => (
          <div key={l} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "16px 18px", boxShadow: "0 2px 6px rgba(0,0,0,.04)" }}>
            <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700, marginBottom: 5, textTransform: "uppercase", letterSpacing: .4 }}>{l}</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: c }}>{v}</div>
          </div>
        ))}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
        {[{ title: "Monthly Leads", data: an.leadsPerMonth || [], color: C.orange }, { title: "Monthly Revenue", data: an.orderRevenue || [], color: C.teal }].map(ch => (
          <div key={ch.title} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "16px 18px", boxShadow: "0 2px 6px rgba(0,0,0,.04)" }}>
            <h3 style={{ color: C.blue, fontSize: 13.5, fontWeight: 700, marginBottom: 14 }}>{ch.title}</h3>
            <div style={{ display: "flex", alignItems: "flex-end", gap: 3, height: 80 }}>
              {ch.data.map((v, i) => {
                const mx = Math.max(...ch.data, 1);
                return (
                  <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
                    <div style={{ width: "100%", background: ch.color, borderRadius: "2px 2px 0 0", height: Math.max(3, (v / mx) * 72) + "px", opacity: .65 + ((i / 12) * .35) }} />
                    <span style={{ fontSize: 8, color: "#94a3b8" }}>{(MONTHS[i] || "").slice(0, 1)}</span>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      <div className="grid-2">
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "16px 18px", boxShadow: "0 2px 6px rgba(0,0,0,.04)" }}>
          <h3 style={{ color: C.blue, fontSize: 13.5, fontWeight: 700, marginBottom: 14 }}>Leads by Service</h3>
          {(an.serviceBreakdown || []).map((s2, i) => {
            const cols = [C.orange, C.blue, C.teal, "#7c3aed"];
            return (
              <div key={s2.name} style={{ marginBottom: 11 }}>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, marginBottom: 4 }}><span style={{ fontWeight: 600, color: C.dark }}>{s2.name}</span><span style={{ color: cols[i], fontWeight: 700 }}>{s2.value}%</span></div>
                <div style={{ background: "#f1f5f9", borderRadius: 4, height: 7 }}><div style={{ width: s2.value + "%", height: "100%", background: cols[i], borderRadius: 4 }} /></div>
              </div>
            );
          })}
        </div>
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "16px 18px", boxShadow: "0 2px 6px rgba(0,0,0,.04)" }}>
          <h3 style={{ color: C.blue, fontSize: 13.5, fontWeight: 700, marginBottom: 14 }}>Top Products</h3>
          {(an.topProducts || []).map((p, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px 0", borderBottom: "1px solid #f9fafb" }}>
              <span style={{ fontSize: 13, color: C.dark, fontWeight: 500 }}>{i + 1}. {p}</span>
              <span style={{ fontSize: 11, color: C.gray, background: "#f1f5f9", padding: "2px 8px", borderRadius: 20 }}>Top Seller</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
